import React, { FC } from 'react';
import { Box, ProgressCircle, Flex } from '@creditas-ui/react';
import {
  MiniCardContainer,
  MiniImage,
  ProgressContainer,
  ResponsiveLabel,
} from './Card.styles';
import { useAutoCard } from './Card.hook';

export const Card: FC = () => {
  const { autoInfo, isSuccess, isLoading } = useAutoCard();
  if (isLoading)
    return (
      <ProgressContainer>
        <ProgressCircle size="large" />
      </ProgressContainer>
    );
  if (isSuccess && autoInfo) {
    return (
      <MiniCardContainer>
        <Flex justifyContent="space-between" alignItems="center" paddingY="5px">
          <MiniImage src={autoInfo.mainPictureUrl} />
          <Box>
            <ResponsiveLabel variant="bodyMdBold" color="neutral.90">
              {`${autoInfo.brandName} ${autoInfo.modelName}`}
            </ResponsiveLabel>
            <ResponsiveLabel variant="bodyMdRegular" color="neutral.80">
              {`${autoInfo.year} | ${autoInfo.kmTraveled} Kms`}
            </ResponsiveLabel>
          </Box>
          <ResponsiveLabel variant="bodyMdBold" color="neutral.90">
            {`${autoInfo.price}`}
          </ResponsiveLabel>
        </Flex>
      </MiniCardContainer>
    );
  }
  return null;
};
